module.exports = __webpack_public_path__ + "img/about_cont_ewm_w.217d08ca.png";